import { useEffect, useLayoutEffect } from 'react';

import { isServer } from '../../utils/is-server';

export const useIsomorphicLayoutEffect = isServer ? useEffect : useLayoutEffect;
